<app-shipment-system-simplenav></app-shipment-system-simplenav>
<div class="container">

    <div class="card  mt-3">
        <div class="card-body">
            <p *ngIf="!bundle" class="text-center  text-muted  mt-2">Indlæser ...</p>

            <div *ngIf="bundle">
                <div class="d-flex  justify-content-between  mb-4">
                    <div>
                        <button class="btn  btn-primary" (click)="save()">Gem</button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label" for="bundle-name">Rute Navn</label>
                        <input type="text" [(ngModel)]="bundle.name" class="form-control" id="bundle-name"
                               placeholder="Indtast rute navn"
                               name="bundle-name">

                    </div>

                    <div class="col-md-4">
                        <label class="form-label" for="bundle-name">Rute Initialer</label>
                        <input type="text" [(ngModel)]="bundle.driver_initials" class="form-control" id="rute-init"
                               placeholder="Indtast rute initialer"
                               name="bundle-initaler">
                    </div>

                    <div class="col-md-4">

                        <label class="form-label" i18n>Branch</label>
                        <span *ngIf="saving" class="text-muted" style="margin-left: 10px;" i18n>Saving...</span>
                        <select class="form-control  form-select"
                                name="shipment-route-id"
                                (change)="branchChanged()"
                                [(ngModel)]="bundle.branch"
                                [disabled]="saving">
                            <option i18n [value]="null">No branch assigned</option>
                            <ng-template ngFor let-branch [ngForOf]="branches">
                                <option [value]="branch.key">{{ branch.name }}
                                </option>
                            </ng-template>
                        </select>
                    </div>

                    <div class="col-md-4">

                        <label class="form-label" i18n>Chauffør</label>
                        <span *ngIf="saving" class="text-muted" style="margin-left: 10px;" i18n>Saving...</span>
                        <select class="form-control  form-select"
                                name="shipment-route-id"
                                (change)="branchChanged()"
                                [(ngModel)]="bundle.shipment_driver_id"
                                [disabled]="saving">
                            <option i18n [value]="null">No Driver assigned</option>
                            <ng-template ngFor let-driver [ngForOf]="shipmentDrivers">
                                <option [value]="driver.id">{{ driver.name }} ({{ driver.branch }})
                                </option>
                            </ng-template>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <label class="form-label" for="scanapp_external_reference">Rute</label>
                        <input type="text" [(ngModel)]="bundle.driver" class="form-control"
                               placeholder="Indtast Rute ID (f.eks. A)"
                               id="scanapp_external_reference" name="scanapp_external_reference">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label" for="trip">Tur</label>
                        <input type="text" [(ngModel)]="bundle.trip" class="form-control" id="trip"
                               placeholder=""
                               name="trip">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label" for="sort">Sortering</label>
                        <input type="text" [(ngModel)]="bundle.sort" class="form-control" id="sort"
                               placeholder=""
                               name="sort">
                    </div>

                    <div class="col-md-4">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox"
                                       [(ngModel)]="bundle.is_global"
                                       [ngModelOptions]="{standalone: true}">
                                is_global
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
